// extracted by mini-css-extract-plugin
export default {"root":"om8jEgf6mNYin7Tuc2Ub","onTop":"tVhdRO57D2fPPnNRTilN","placeHolderShimmer":"d1b2MSzN4Xq7dn1OVstt"};